"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _AudioContent = _interopRequireDefault(require("./AudioContent"));

var _CommonCard = _interopRequireDefault(require("./CommonCard"));

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = (0, _connectToWebChat.default)(function (_ref) {
  var styleSet = _ref.styleSet;
  return {
    styleSet: styleSet
  };
})(function (_ref2) {
  var adaptiveCards = _ref2.adaptiveCards,
      attachment = _ref2.attachment,
      _ref2$attachment = _ref2.attachment;
  _ref2$attachment = _ref2$attachment === void 0 ? {} : _ref2$attachment;
  var _ref2$attachment$cont = _ref2$attachment.content,
      content = _ref2$attachment$cont === void 0 ? {} : _ref2$attachment$cont,
      styleSet = _ref2.styleSet;
  return _react.default.createElement("div", {
    className: styleSet.audioCardAttachment
  }, _react.default.createElement("ul", {
    className: "media-list"
  }, content.media.map(function (media, index) {
    return _react.default.createElement("li", {
      key: index
    }, _react.default.createElement(_AudioContent.default, {
      autoPlay: content.autostart,
      loop: content.autoloop,
      poster: content.image && content.image.url,
      src: media.url
    }));
  })), _react.default.createElement(_CommonCard.default, {
    adaptiveCards: adaptiveCards,
    attachment: attachment
  }));
});

exports.default = _default;